import React, { useEffect, useState, useContext } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import { Layout, Menu, Avatar, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import 'moment/locale/pt-br';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { ApplicationState } from '../../store';
import { RouteType } from '../../routes/routeType';
import { cleanState } from '../../store/ducks/auth/actions';
import { PRIVATE_ROUTES } from '../../routes/routes';

import {
  Container,
  AuthData,
  UserData,
  ContainerData,
  Username,
  Login,
  ContainerDataResponsive,
  Content,
  Div,
  AvatarRegular,
  SwitchTheme,
} from './styles';
import NaoAutorizado from '../../components/NaoAutorizado';
import { useTheme } from '../../hook/theme';
import { lightTheme, darkTheme } from '../../styles/themes';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './global';
import { AnchorContext } from '../../context/anchor';
import Swal from 'sweetalert2';
import api from '../../service/api';
import { SKW_PREFIX } from '../../utils/constants';
import Footer from './Footer';
import Notifications from '../../components/Notifications';
import SiderMenu from './Sider';
import BoxSelect from './BoxSelect';
import { THEME_MODE } from 'utils/enums/theme.enum';

const BasicLayout: React.FC = () => {
  const { token, user } = useSelector((state: ApplicationState) => state.auth);
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil);
  const history = useHistory();
  const [collapsed, setCollapsed] = useState(false);
  const [redirect, setRedirect] = useState<string | undefined>(undefined);
  const { Header } = Layout;
  const { theme, themeToggler } = useTheme();
  const dispatch = useDispatch();
  const { linkAvatar } = useContext(AnchorContext);

  useEffect(() => {
    try {
      api
        .post(`call?serviceName=${SKW_PREFIX}getConsultaAtualizacao&token=${token}`, {})

        .then((res) => {
          if (res.data.dtInicio) {
            Swal.fire({
              title: `Atualização do sistema!`,
              html: `Olá, o portal kothelog será atualizado em <div><strong>${res?.data.dtInicio} às ${res?.data.htInicio}</strong></div> com previsão de término às ${res?.data.htFim}`,
              padding: '3em',
              background: '#fff ',
              backdrop: `#0c2135c1`,
              imageUrl: 'http://log.kothe.com.br/email/logo-kothe.png',
              imageAlt: 'logo da kothelog',
            });
          }
        })

        .catch(function (error) {
          if (error.response) {
            // A requisição foi feita e o servidor respondeu com um código de status
            // que sai do alcance de 2xx
            console.error(error.response.data);
          }
        });
    } catch (error) {}
  }, [token, user]);

  useEffect(() => {
    if (!token) {
      dispatch(cleanState());
      setRedirect('/login');
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (window.location.pathname === redirect) setRedirect(undefined);
  }, [redirect]);

  const renderRoutes = (prop: RouteType, index: number) => {
    return (
      <Route
        path={`${prop.layout}${prop.path}`}
        component={prop?.roles.includes(perfil ?? '') ? prop.component : NaoAutorizado}
        key={index}
        exact
      />
    );
  };

  const menuRegular = (
    <Menu>
      <ContainerDataResponsive>
        <Div>
          <Button type="link" onClick={() => history.push('/dashboard/meusdados')}>
            <UserOutlined /> Meus dados
          </Button>
        </Div>

        <Button
          type="link"
          danger
          onClick={() => {
            setTimeout(() => {
              history.push('/dashboard/logout');
            }, 2000);
          }}
        >
          <LogoutOutlined /> Sair
        </Button>
      </ContainerDataResponsive>
    </Menu>
  );

  return (
    <ThemeProvider theme={theme === THEME_MODE.light ? lightTheme : darkTheme}>
      <Container>
        <Layout>
          <SiderMenu collapsed={collapsed} setCollapsed={setCollapsed} theme={theme} />

          <Layout>
            <Header className="header-menu">
              {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                onClick: () => setCollapsed(!collapsed),
              })}
              <AuthData>
                <Notifications />
                <BoxSelect />

                <UserData>
                  <AvatarRegular key="more" overlay={menuRegular}>
                    <ContainerData>
                      <span>
                        <Avatar src={linkAvatar} icon={<UserOutlined />} size={32} />
                      </span>
                      <span>
                        <Username>{user?.nome}</Username>
                        <Login className="email">{user?.email}</Login>
                      </span>
                    </ContainerData>
                  </AvatarRegular>
                </UserData>
              </AuthData>

              {/* <AvatarMenu key="more" /> */}

              <SwitchTheme
                defaultChecked={true}
                onChange={themeToggler}
                checkedChildren="Claro"
                unCheckedChildren="Escuro"
                checked={theme === THEME_MODE.light}
              />
            </Header>

            <Content>
              {redirect && <Redirect to={{ pathname: redirect }} />}
              <Switch>{PRIVATE_ROUTES.map(renderRoutes)}</Switch>
              {!token && <Redirect to={{ pathname: '/login' }} />}
              <Footer />
            </Content>
          </Layout>
        </Layout>
      </Container>
      <GlobalStyle />
    </ThemeProvider>
  );
};

export default BasicLayout;
